import React from 'react';
import { Smartphone } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '../ui/button';

// Shown only when the web session was opened from the mobile app (auth handoff).
export const BackToAppBar = () => {
  const { t } = useTranslation('onboarding');
  const fromApp = sessionStorage.getItem('nymia_from_app') === '1';
  const returnUrl = sessionStorage.getItem('nymia_app_return_url') || '';
  if (!fromApp && !returnUrl) return null;

  return (
    <div
      className="mb-4 flex flex-col gap-3 rounded-xl border border-[#D4AF37]/35 bg-[#D4AF37]/[0.06] px-4 py-3 sm:flex-row sm:items-center sm:justify-between"
      data-testid="back-to-app-bar"
    >
      <div className="flex items-start gap-2.5">
        <Smartphone className="mt-0.5 h-4 w-4 shrink-0 gold-text" />
        <div>
          <p className="text-[13px] font-semibold text-foreground">{t('app_return.title')}</p>
          <p className="text-[12px] text-muted-foreground">
            {returnUrl ? t('app_return.hint') : t('app_return.no_link')}
          </p>
        </div>
      </div>
      {returnUrl && (
        <Button asChild className="gold-gradient shrink-0 text-black" data-testid="back-to-app-btn">
          <a href={returnUrl}>{t('app_return.cta')}</a>
        </Button>
      )}
    </div>
  );
};

export default BackToAppBar;
